import { DocumentIcon, PresentationChartBarIcon } from "@heroicons/react/20/solid"
import { PrimaryFeatureFrame } from "../PrimaryFeatureFrame"

export function Export() {
    return (
        <PrimaryFeatureFrame>
            <div className="flex h-full flex-col justify-center">
                <div className="-mt-24 flex flex-col justify-center">
                    <div className="mb-10 text-center font-semibold">Export as</div>
                    <div className="flex flex-row justify-center space-x-16">
                        <div className="rounded-lg border-2 border-primary-600/50 bg-gray-50 p-4 text-center">
                            <DocumentIcon className="mx-auto mb-5 size-36 text-teal-600/60" aria-hidden="true" />
                            <span className="text-gray-700">Short report</span>
                        </div>
                        <div className="rounded-lg bg-gray-50 p-4 text-center">
                            <PresentationChartBarIcon
                                className="mx-auto mb-5 size-36 text-teal-600/60"
                                aria-hidden="true"
                            />
                            <span className="text-gray-700">Presentation</span>
                        </div>
                    </div>
                </div>
            </div>
        </PrimaryFeatureFrame>
    )
}
